import SetFiscalRegimeError from './SetFiscalRegimeError';
class InvalidFileType extends SetFiscalRegimeError {
    constructor(options) {
        super('Fiscal regime file type is invalid', options);
    }
}
export default InvalidFileType;
